module.exports = __webpack_public_path__ + "media/images/sp_header_btn_beginner-0e87c02fe8250465c56ab4bd5b47e2e4.png";